// _hsq helpers for the HubSpot tracking code (portal 8693713), which loads from
// the GTM-K4WKF75L container bootstrapped in public/index.html. Pushing before
// the loader runs is harmless — the array just accumulates (mirrors gtmPush).
export function hsPush(...args: unknown[]): void {
  const w = window as unknown as { _hsq?: unknown[][] };
  w._hsq = w._hsq || [];
  w._hsq.push(args);
}

// Ties the current visitor cookie to a contact. HubSpot queues the identity and
// only sends it with the NEXT tracked event, so pair this with a pageview: the
// App-level route tracking covers navigations, and high-value form successes
// flush explicitly with hsPush('trackPageView').
export function hsIdentify(email: string, props?: Record<string, unknown>): void {
  if (!email) return;
  hsPush('identify', { email, ...props });
}

// SPA virtual pageview — HubSpot only auto-tracks the landing page.
export function hsTrackPage(path: string): void {
  hsPush('setPath', path);
  hsPush('trackPageView');
}
